import React, { Component } from 'react';

import LegendValues from '../b-LeafletMap/Legend/LegendValues';
import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendResidentialArea from '../b-LeafletMap/Legend/LegendResidentialArea';

import getMyMap, {createCommunesLayer, createCommuneMassLayer, createResidentialAreasMassLayer,
                  getLegendMode, createCommuneBordersLayer, createCommunesNamesLayerEasy} from './leaflet_map';

import {c_missing_data, c_gradient_greens} from '../a-Graphic/Colors';

class LeafletMapCarFleet extends React.Component {
  constructor(props){
    super(props)

    this.mode = "ckmeans"
    this.colors = c_gradient_greens
  }

  componentDidMount() {
    // --- init map
    var mymap = this.mymap = getMyMap(this.props.id, true);
    var layer = this.layer = createCommuneMassLayer(mymap, this.props.communes_wd, this.props.masses, this.props.labels, this.mode, this.colors);
    var layer2 = this.layer2 = createCommunesLayer(mymap, this.props.communes_nd, null, c_missing_data);
    createCommunesNamesLayerEasy(mymap, this.props.communes)
    // --- center the map
    mymap.fitBounds(layer.getBounds());

  }

  componentDidUpdate() {
    // --- update areas
    this.mymap.removeLayer(this.layer);

    this.layer = createCommuneMassLayer(this.mymap, this.props.communes_wd, this.props.masses, this.props.labels, this.mode, this.colors);
    this.layer2 = createCommunesLayer(this.mymap, this.props.communes_nd, null, c_missing_data);
  }

  render() {
    let values = this.props.masses;
    let [intervals, colors] = getLegendMode(this.mode, values, this.colors);
    return(

        <div className="row align-items-end">
          <div className="col-10">
            <div style={{height: "500px"}} id={this.props.id}></div>
          </div>

          <div className="col-2 pl-0 pr-0">
            <LegendCommune label={this.props.legend_label} />
            <LegendValues intervals={intervals} colors={colors} missing_data={this.props.missing_data}/>
          </div>
        </div>
    )
  }
}

export default LeafletMapCarFleet;
